import React from 'react';

interface Props {
  className?: string;
}

export const Instagram: React.FC<Props> = ({ className, ...rest }) => (
  <svg
    className={className}
    fill="none"
    height="18"
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      clipRule="evenodd"
      d="M9 0C6.556 0 6.25 0.01 5.29 0.054C4.33 0.098 3.677 0.25 3.105 0.472C2.513 0.702 2.011 1.01 1.511 1.512C1.011 2.012 0.704 2.512 0.474 3.105C0.251 3.677 0.099 4.331 0.054 5.289C0.01 6.25 0 6.555 0 9C0 11.445 0.01 11.75 0.054 12.71C0.098 13.67 0.25 14.323 0.472 14.896C0.702 15.488 1.01 15.99 1.51 16.49C2.01 16.99 2.512 17.298 3.104 17.528C3.676 17.75 4.331 17.903 5.289 17.946C6.249 17.99 6.555 18 8.999 18C11.443 18 11.749 17.99 12.709 17.946C13.669 17.902 14.322 17.75 14.895 17.528C15.487 17.298 15.989 16.99 16.489 16.49C16.989 15.99 17.297 15.488 17.527 14.896C17.749 14.324 17.902 13.669 17.945 12.711C17.989 11.751 17.999 11.445 17.999 9.001C17.999 6.557 17.989 6.251 17.945 5.291C17.901 4.331 17.749 3.678 17.527 3.105C17.297 2.513 16.989 2.011 16.489 1.511C15.989 1.011 15.487 0.703 14.895 0.473C14.323 0.251 13.668 0.098 12.71 0.055C11.75 0.01 11.445 0 9 0ZM9 1.622C11.403 1.622 11.688 1.632 12.637 1.674C13.514 1.714 13.991 1.861 14.307 1.984C14.727 2.147 15.027 2.342 15.343 2.657C15.658 2.972 15.853 3.272 16.016 3.692C16.139 4.009 16.286 4.486 16.326 5.362C16.369 6.312 16.378 6.597 16.378 9C16.378 11.403 16.368 11.688 16.326 12.637C16.286 13.514 16.139 13.991 16.016 14.307C15.853 14.727 15.658 15.027 15.343 15.343C15.028 15.658 14.728 15.853 14.308 16.016C13.991 16.139 13.514 16.286 12.638 16.326C11.688 16.369 11.404 16.378 9 16.378C6.596 16.378 6.312 16.368 5.363 16.326C4.486 16.286 4.009 16.139 3.693 16.016C3.273 15.853 2.973 15.658 2.657 15.343C2.342 15.028 2.147 14.728 1.984 14.308C1.861 13.991 1.714 13.514 1.674 12.638C1.631 11.688 1.622 11.403 1.622 9C1.622 6.597 1.632 6.312 1.674 5.363C1.714 4.486 1.861 4.009 1.984 3.693C2.147 3.273 2.342 2.973 2.657 2.657C2.972 2.342 3.272 2.147 3.692 1.984C4.009 1.861 4.486 1.714 5.362 1.674C6.312 1.631 6.597 1.622 9 1.622ZM4.378 9C4.378 6.448 6.448 4.378 9 4.378C11.552 4.378 13.622 6.448 13.622 9C13.622 11.552 11.552 13.622 9 13.622C6.448 13.622 4.378 11.552 4.378 9ZM9 12C7.343 12 6 10.657 6 9C6 7.343 7.343 6 9 6C10.657 6 12 7.343 12 9C12 10.657 10.657 12 9 12ZM12.724 4.196C12.724 3.6 13.208 3.116 13.804 3.116C14.401 3.116 14.884 3.6 14.884 4.196C14.884 4.792 14.4 5.276 13.804 5.276C13.208 5.276 12.724 4.792 12.724 4.196Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

export const Facebook: React.FC<Props> = ({ className, ...rest }) => (
  <svg
    className={className}
    fill="none"
    height="18"
    viewBox="0 0 18 18"
    width="18"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      clipRule="evenodd"
      d="M17 0H1C0.4 0 0 0.4 0 1V17C0 17.5 0.4 18 1 18H9.6V11H7.3V8.3H9.6V6.3C9.6 4 11 2.7 13.1 2.7C14.1 2.7 14.9 2.8 15.2 2.8V5.2H13.8C12.7 5.2 12.5 5.7 12.5 6.5V8.2H15.2L14.8 11H12.5V18H17C17.5 18 18 17.6 18 17V1C18 0.4 17.6 0 17 0Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

export const Menu: React.FC<Props> = ({ className, ...rest }) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M4 6h16M4 12h16M4 18h16"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    />
  </svg>
);

export const Close: React.FC<Props> = ({ className, ...rest }) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M6 18L18 6M6 6l12 12"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    />
  </svg>
);

export const ChartBar: React.FC<Props> = ({ className, ...rest }) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    />
  </svg>
);

export const ChevronDown: React.FC<Props> = ({ className, ...rest }) => (
  <svg
    className={className}
    fill="currentColor"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      clipRule="evenodd"
      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
      fillRule="evenodd"
    />
  </svg>
);

export const LocationMarker: React.FC<Props> = ({ className, ...rest }) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    />
    <path
      d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    />
  </svg>
);

export const Mail: React.FC<Props> = ({ className, ...rest }) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    />
  </svg>
);

export const Phone: React.FC<Props> = ({ className, ...rest }) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    />
  </svg>
);

export const ArrowRight: React.FC<Props> = ({ className, ...rest }) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M14 5l7 7m0 0l-7 7m7-7H3"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    />
  </svg>
);

export const Quotes: React.FC<Props> = ({ className, ...rest }) => (
  <svg
    className={className}
    fill="currentColor"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path d="M11.192 15.757c0-.88-.23-1.618-.69-2.217-.326-.412-.768-.683-1.327-.812-.55-.128-1.07-.137-1.54-.028-.16-.95.1-1.956.76-3.022.66-1.065 1.515-1.867 2.558-2.403L9.373 5c-.8.396-1.56.898-2.26 1.505-.71.607-1.34 1.305-1.9 2.094s-.98 1.68-1.25 2.69-.346 2.04-.217 3.1c.168 1.4.62 2.52 1.356 3.35.735.84 1.652 1.26 2.748 1.26.965 0 1.766-.29 2.4-.878.628-.576.94-1.365.94-2.368l.002.003zm9.124 0c0-.88-.23-1.618-.69-2.217-.326-.42-.77-.692-1.327-.817-.56-.124-1.074-.13-1.54-.022-.16-.94.09-1.95.75-3.02.66-1.06 1.514-1.86 2.557-2.4L18.49 5c-.8.396-1.555.898-2.26 1.505-.708.607-1.34 1.305-1.894 2.094-.556.79-.97 1.68-1.24 2.69-.273 1-.345 2.04-.217 3.1.165 1.4.615 2.52 1.35 3.35.732.833 1.646 1.25 2.742 1.25.967 0 1.768-.29 2.402-.876.627-.576.942-1.365.942-2.368v.01z" />
  </svg>
);

export const Building: React.FC<Props> = ({ className, ...rest }) => (
  <svg
    className={className}
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M15.3654 21H12M15.3654 21H19V16.1538M15.3654 21V16.1684M5 7.07368C10.4673 7.07368 9.89804 7.07368 15.3654 7.07368M15.3654 7.07368V11.7789M15.3654 7.07368V3H12M15.3654 7.07368H19V11.7789M5 11.7789V3H8.5M5 11.7789V21H8.5M5 11.7789H15.3654M15.3654 11.7789H19M15.3654 11.7789V16.1684M5 16.1684H12H15.3654M15.3654 16.1684L19 16.1538M8.5 3V21M8.5 3H12M8.5 21H12M12 3V21M19 11.7789V16.1538"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

export const Road: React.FC<Props> = ({ className, ...rest }) => (
  <svg
    className={className}
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M4 21L6.72727 3M19 21L16.2727 3M11.5 21V15.4615M11.5 14.0769V9.23077M11.5 7.84615V3.69231"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

export const Drop: React.FC<Props> = ({ className, ...rest }) => (
  <svg
    className={className}
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M18.25 13.6265C18.25 17.3218 15.4155 20.25 12 20.25C8.58448 20.25 5.75 17.3218 5.75 13.6265C5.75 12.7993 6.11431 11.7612 6.75013 10.611C7.37657 9.47779 8.22147 8.31524 9.08141 7.25992C9.93912 6.20735 10.7989 5.27714 11.4452 4.60931C11.6557 4.39178 11.8432 4.20253 12 4.04644C12.1568 4.20253 12.3443 4.39178 12.5548 4.60931C13.2011 5.27714 14.0609 6.20735 14.9186 7.25992C15.7785 8.31524 16.6234 9.47779 17.2499 10.611C17.8857 11.7612 18.25 12.7993 18.25 13.6265Z"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);
